/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Image_Export_Preview_FailedInputs */



/**
* | output |
* | --- |
* | "Preview generation failed: {error}" |
*
* @param {Image_Export_Preview_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_preview_failed = /** @type {((inputs: Image_Export_Preview_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Preview_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de la generation de la previsualisation : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Vorschau-Generierung fehlgeschlagen: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Generazione dell'anteprima non riuscita: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось создать предварительный просмотр: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error en la generación de la vista previa: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`预览生成失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プレビュー生成に失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`पूर्वावलोकन निर्माण विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A geração da pré-visualização falhou: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Preview generation failed: ${i?.error}`)
});